var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3704_53991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4912 13.5049V13.1299H11.1162H10.4276L12.3651 10.8172L14.3267 13.1299H13.6704H13.2954V13.5049V16.0627H11.4912V13.5049Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18925 0.5L8.43994 0.500038L12.9752 5.04151V10.9528L12.457 10.3466L9.70157 13.4951L11.472 13.4951V15.9307L2.18923 15.9306C1.45706 15.9306 0.863525 15.3371 0.863525 14.6049V1.82571C0.863525 1.09354 1.45707 0.499995 2.18925 0.5ZM8.3584 1.47681V5.11895H11.9985L8.3584 1.47681ZM4.9602 10.4313C5.10139 10.4313 5.24291 10.397 5.33338 10.3634L5.4064 10.8723C5.29331 10.9288 5.09558 10.9679 4.84679 10.9679C3.97637 10.9679 3.47913 10.2558 3.47913 9.08009C3.47913 7.61646 4.25359 7.09078 4.93177 7.09078C5.18055 7.09078 5.35535 7.14119 5.42934 7.18674L5.31625 7.70111C5.22578 7.65556 5.13532 7.62195 4.95438 7.62195C4.54179 7.62195 4.11789 8.00062 4.11789 9.04067C4.11789 10.0636 4.50237 10.4313 4.9602 10.4313ZM6.69329 10.9683C6.41058 10.9683 6.12238 10.8894 6.00348 10.8099L6.10558 10.2904C6.24677 10.3751 6.49555 10.4429 6.69361 10.4429C7.06679 10.4429 7.27034 10.228 7.27034 9.91109C7.27034 9.60609 7.08391 9.43097 6.77277 9.21579C6.34887 8.94471 6.05485 8.56604 6.05485 8.15345C6.05485 7.55992 6.45614 7.09111 7.16856 7.09111C7.41121 7.09111 7.63253 7.16445 7.73398 7.22681L7.62639 7.74667C7.51945 7.67882 7.36081 7.61678 7.15725 7.61678C6.81251 7.61678 6.64838 7.84812 6.64838 8.08043C6.64838 8.37444 6.80088 8.51015 7.19118 8.75861C7.67162 9.07492 7.86354 9.4426 7.86354 9.84938C7.86354 10.5334 7.37761 10.9683 6.69329 10.9683ZM9.03412 10.9679H9.70713L10.5989 7.09078H9.93168L9.62086 8.81644C9.54009 9.26522 9.45382 9.75988 9.40213 10.2371H9.385C9.33855 9.85633 9.26575 9.44921 9.20013 9.08232C9.18454 8.99511 9.16929 8.90984 9.15496 8.82807L8.83316 7.09078H8.16015L9.03412 10.9679Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3704_53991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.446289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsv);
export default __webpack_public_path__ + "static/media/upload-csv.13f9ff12c98610d1686b255c5df13a84.svg";
export { ForwardRef as ReactComponent };